var $7dc4cab4e747b00a$exports = {};
$7dc4cab4e747b00a$exports = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `V\xe4rvivalija`,
    "colorSwatch": `v\xe4rvin\xe4idis`,
    "transparent": `l\xe4bipaistev`,
    "twoDimensionalSlider": `2D-liugur`
};


export {$7dc4cab4e747b00a$exports as default};
//# sourceMappingURL=et-EE.mjs.map
